export const isDefinedAndNotNull = (val) => {
    return val !== undefined && val !== null;
};
export const filterOutNullOrUndefined = (arr) => {
    return arr.filter(isDefinedAndNotNull);
};
//# sourceMappingURL=isDefinedAndNotNull.js.map